import Marketplace from '../contracts/Marketplace'
import Nft from '../contracts/ERC721Full'
import { fromWei } from 'web3-utils'

const toUsd = (amount, rate) => {
  const ether = fromWei(`${amount}`, 'ether')
  return Math.round(ether * rate * 100) / 100
}

const rnd = (amount) => {
  const ether = fromWei(`${amount}`, 'ether')
  return Math.floor(ether * 1000) / 1000
}

const getContracts = async (web3) => {
    // Use web3 to get the user's accounts.
  web3.eth.handleRevert = true
  const networkId = await web3.eth.net.getId()

  let instanceMarketplace = null
  let instanceNft = null
  if (typeof Nft.networks[networkId.toString()] !== 'undefined' && typeof Marketplace.networks[networkId.toString()] !== 'undefined') {
    let deployedNetwork = Marketplace.networks[networkId.toString()]
    if (deployedNetwork) {
      instanceMarketplace = new web3.eth.Contract(
        Marketplace.abi,
        deployedNetwork.address,
      )
    }
    deployedNetwork = Nft.networks[networkId.toString()]
    if (deployedNetwork) {
      instanceNft = new web3.eth.Contract(
        Nft.abi,
        deployedNetwork.address,
      )
    }
  }

  return {
    Marketplace: instanceMarketplace,
    Nft: instanceNft,
  }
}

export { getContracts, toUsd, rnd }